


import React, { Component} from 'react'
import ReactPlayer from 'react-player';
import { InitialsContainer } from './InitialsContainer';

import './ProducerPlayer.scss';

type MyProps = {
  // using `interface` is also ok
  url: string,
  streamIndex: number,
  audioMute: boolean,
  videoMute: boolean,
  initials: string,
  camera: string,
};
type MyState = {
  url: string,
  streamIndex: number,
  type: string,
  playing: boolean,
  controls: boolean,
  audioMute: boolean,
  videoMute: boolean,
  initials: string,
  zoom: string,
  camera: string,
};


class ProducerPlayerComponent extends Component<MyProps, MyState> {
  player:  any = '';

  state: MyState = {
    url: '',
    streamIndex: 0,
    type: '',
    playing: true,
    controls: false,
    audioMute: true,
    videoMute: false,
    initials: '',
    zoom: '104%',
    camera: '',
  }

  minTime = 500;
  lastActionDate = 0;

  constructor(props: any) {
    super(props);
    const zoom = props.url.indexOf('contentshare') >= 0 ?  '100%' : '104%';

    this.state = {
      ...this.state,
      audioMute: props.audioMute,
      videoMute: props.videoMute,
      initials: props.initials,
      url: props.url,
      streamIndex: props.streamIndex,
      camera: props.camera,
      zoom,
    };
    // this.load(props);

  }

  UNSAFE_componentWillReceiveProps(props) {
    // console.log('componentWillReceiveProps', props);
    const zoom = props.url.indexOf('contentshare') >= 0 ?  '100%' : '104%';

    this.setState({
       audioMute: props.audioMute,
       videoMute: props.videoMute,
       initials: props.initials,
       url: props.url,
       streamIndex: props.streamIndex,
       camera: props.camera,
       zoom,
     })
  }


  ref = (player: any) => {
    this.player = player
  }

  render() {


    if (this.state.url && this.state.url.indexOf('webrtc') >= 0 && !this.state.videoMute) {

      return (
        <div className='stream-wrapper'>
          <div className='stream-player'>
            <video id={'card-' + this.state.url}
            playsInline muted autoPlay className="stream-video"></video>
          </div>
        </div>
      );
    } else if (this.state.url !== '' && this.state.videoMute) {

        return (
          <div className='stream-wrapper'>
            <div className='stream-player'>
              <InitialsContainer>{this.state.initials}</InitialsContainer>
            </div>
          </div>
        );
    } else if (this.state.url && this.state.url.indexOf('showing-local-content') >= 0) {
      return (
        <div className='stream-wrapper local-content'>
          <div className='local-content-logo'></div>
          <div className='local-content-heading'>You are sharing your screen</div>
          {/* <div className='local-content-description'>Other participants will see the applications and documents on your screen.</div> */}
        </div>
      )
    } else {
      // fake player for demo
      return(
          <div className='player-wrapper'>
              <ReactPlayer
                className='player-react'
                width={this.state.zoom}
                height={this.state.zoom}
                ref={this.ref}
                url={this.state.url}
                playing = {this.state.playing}
                controls={this.state.controls}
                muted= {this.state.audioMute}
                loop={true}
                onError={e => console.log('onError', e)}
              />
          </div>
      )
    }
  }
}

export default ProducerPlayerComponent;